import { render } from "./vehicleConfig.vue?vue&type=template&id=1d622e92"
import script from "./vehicleConfig.vue?vue&type=script&lang=js"
export * from "./vehicleConfig.vue?vue&type=script&lang=js"

import "./vehicleConfig.vue?vue&type=style&index=0&id=1d622e92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__